<template>
  <transition name="fade">
    <div class="popup" :class="{ 'top-150': $route.name === 'ReportsShow' }" v-show="popupShown">
      <p>{{ message }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  beforeDestroy() {
    this.$eventBus.$off('show-popup', this.showPopup);
  },
  created() {
    this.$eventBus.$on('show-popup', this.showPopup);
  },
  data() {
    return {
      message: 'Please pass the message with the $emit call',
      popupShown: false,
    };
  },
  methods: {
    showPopup(textToDisplay) {
      this.message = textToDisplay;
      this.popupShown = true;
      window.setTimeout(() => {
        this.popupShown = false;
      }, 3000);
    },
  },
  name: 'Popup',
};
</script>

<style scoped>
.popup {
  position: fixed;
  top: 100px;
  left: 50%;
  margin-top: -50px;
  margin-left: -50px;
  width: 230px;
  height: 70px;
  color: #fff;
  background-color: #1a75cf;
  text-align: center;
  border-radius: 15px;
  z-index: 50;
  padding: 10px;
  padding-top: 30px;
}

.top-150 {
  top: 150px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to
  /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
